/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_InfoInputs */



/**
* | output |
* | --- |
* | "Organization base models are always available to all teams. Use this to assign additional models to this team." |
*
* @param {Team_Models_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_info = /** @type {((inputs?: Team_Models_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Basismodelle der Organisation stehen allen Teams immer zur Verfügung. Verwenden Sie dies, um diesem Team zusätzliche Modelle zuzuweisen.")
	return /** @type {LocalizedString} */ ("Organization base models are always available to all teams. Use this to assign additional models to this team.")
});